export const generateGameId = () => {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
};

export const getStatisticKey = (statisticName) => {
  // Return the statistic name as-is since API provides dynamic stat names
  return statisticName;
};